import { shimmerEffectSvg, toBase64 } from '@/lib/utils'

// Stands in for next/image's blur placeholder: the shimmer shows through the
// element until the image itself paints over it.
const SHIMMER_BACKGROUND = `url("data:image/svg+xml;base64,${toBase64(
  shimmerEffectSvg(700, 475)
)}")`

function CardImage({
  imageUrl,
  name,
  width,
  height
}: {
  imageUrl: string
  name: string
  height?: number
  width?: number
}) {
  return (
    <img
      width={width}
      height={height}
      src={imageUrl}
      alt={name}
      loading="lazy"
      style={{
        backgroundImage: SHIMMER_BACKGROUND,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat'
      }}
      className="max-w-full mb-5 ml-auto mr-auto"
    />
  )
}

export default CardImage
